import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import CartPage from "./pages/CartPage";
import QuotationViewer from "./pages/QuotationViewer";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";



function App() {
  return (
    <Router>
      <LayoutWithConditionalCartDrawer />
    </Router>
  );
}

function LayoutWithConditionalCartDrawer() {
  const location = useLocation();
  const isCartPage = location.pathname === "/cart";
  const isQuotationPage = location.pathname.startsWith("/q/");

  return (
    <div className="min-h-screen bg-white">
      {!isQuotationPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/q/:token" element={<QuotationViewer />} />
      </Routes>
      {!isCartPage && !isQuotationPage && <CartDrawer />}
    </div>
  );
}

export default App;